<template>
  <!-- <div :class="`collections-${$store.state.theme}-common-countdown`" />
    -->
  <!-- eslint-disable -->
  <div class="countdown-badge">
    <span v-html="label"></span>
    <svg
    width="65"
    height="67"
    viewBox="0 0 65 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
        d="M30.5 1.1547C31.7376 0.440169 33.2624 0.440169 34.5 1.1547L58.6458 15.0953C59.8834 15.8098 60.6458 17.1303 60.6458 18.5594V46.4406C60.6458 47.8697 59.8834 49.1902 58.6458 49.9047L34.5 63.8453C33.2624 64.5598 31.7376 64.5598 30.5 63.8453L6.35417 49.9047C5.11657 49.1902 4.35417 47.8697 4.35417 46.4406V18.5594C4.35417 17.1303 5.11657 15.8098 6.35417 15.0953L30.5 1.1547Z"
        fill="var(--white-color)"
        />
        <path
        d="M30.75 1.58789C31.8329 0.962676 33.1671 0.962676 34.25 1.58789L58.3955 15.5283C59.4784 16.1535 60.1455 17.3091 60.1455 18.5596V46.4404C60.1455 47.6909 59.4784 48.8465 58.3955 49.4717L34.25 63.4121C33.1671 64.0373 31.8329 64.0373 30.75 63.4121L6.60449 49.4717C5.52159 48.8465 4.85449 47.6909 4.85449 46.4404V18.5596C4.85449 17.3091 5.52159 16.1535 6.60449 15.5283L30.75 1.58789Z"
        stroke="var(--main-color)"
        />
      </g>
    </svg>
  </div>
</template>
<script>
import TimerMixin from '@/mixins/TimerMixin.vue';

export default {
  name: 'CountdownBadge',
  mixins: [TimerMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    label() {
      if (!this.product || !this.product.subscription) {
        return '';
      }
      const badgeText = this.$config.common.subscription;
      const value = this.product.value;
      return badgeText
        .replace('{days}', this.subscription.days)
        .replace('{value}', value);
    },
  },
};
</script>
<style lang="stylus">
div.countdown-badge {
  width: 65px;
  height: 67px;
  position: relative;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 9px;
    text-align: center;
    line-height: 1.2;
    pointer-events: none;
    z-index: 1;
    font-weight: 700;
    color: var(--inverted-text-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    strong {
      font-size: 19px;
      font-weight: 900;
    }

    em {
      font-style: normal;
      font-size: 9px
    }
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    filter: drop-shadow(1px 2px 0px var(--shadow-color));
    z-index: -1;
  }
}
</style>
